<span class="mb-3 w-100">
  <input type="search" class="w-100 py-1" pInputText  [(ngModel)]="keyword" (search)="reset()"  (keyup)="search($event)" [placeholder]="'KEYWORD'|translate"/>
</span>
